module.exports = __webpack_public_path__ + "img/pic35.a4d468e0.png";